import { render, staticRenderFns } from "./Archiver.vue?vue&type=template&id=58ea4d3a"
import script from "./Archiver.vue?vue&type=script&lang=js"
export * from "./Archiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports